export function Row({ label, value }) {
  return (
    <div className="flex items-center justify-between gap-3">
      <div className="text-slate-600">{label}</div>
      <div className="text-slate-900 font-semibold">{value}</div>
    </div>
  );
}